interface CircularMatchRatingProps {
  percentage: number;
  size?: number;
  strokeWidth?: number;
  showLabel?: boolean;
  labelClassName?: string;
  percentageClassName?: string;
}

const getMatchLevel = (percentage: number) => {
  if (percentage >= 80) return { label: "Excellent", color: "text-green-600" };
  if (percentage >= 60) return { label: "Good", color: "text-emerald-500" };
  if (percentage >= 40) return { label: "Fair", color: "text-amber-500" };
  return { label: "Low", color: "text-red-500" };
};


export const CircularMatchRating = ({
  percentage,
  size = 40,
  strokeWidth = 2,
  showLabel = true,
  labelClassName = "text-xss",
  percentageClassName,
}: CircularMatchRatingProps) => {
  const clamped = Math.min(100, Math.max(0, percentage));
  const { label, color } = getMatchLevel(clamped);

  const radius = (size - strokeWidth) / 2;
  const circumference = 2 * Math.PI * radius;
  const offset = circumference - (clamped / 100) * circumference;

  return (
    <div className="flex items-center gap-4">
      <div className="relative shrink-0" style={{ width: size, height: size }}>
        <svg
          width={size}
          height={size}
          viewBox={`0 0 ${size} ${size}`}
          className={`-rotate-90 ${color}`}
        >
          <circle
            cx={size / 2}
            cy={size / 2}
            r={radius}
            fill="none"
            strokeWidth={strokeWidth}
            className="text-gray-200"
            stroke="currentColor"
          />
          <circle
            cx={size / 2}
            cy={size / 2}
            r={radius}
            fill="none"
            strokeWidth={strokeWidth}
            stroke="currentColor"
            strokeDasharray={circumference}
            strokeDashoffset={offset}
            strokeLinecap="round"
            className="transition-all duration-500"
          />
        </svg>
        <span
          className={`absolute inset-0 flex items-center justify-center font-bold ${color} ${percentageClassName ?? ""}`}
          style={percentageClassName ? undefined : { fontSize: size * 0.28 }}
        >
          {Math.round(clamped)}%
        </span>
      </div>
      {showLabel && (
        <span className={`font-bold ${color} ${labelClassName}`}>
          {label}
        </span>
      )}
    </div>
  );
};